import { useEffect } from 'react'

/**
 * Cierra una ayuda NO modal con Esc (RN-68). Si hay un diálogo modal abierto, Esc es suyo: cerrar también la
 * ayuda de fondo con la misma tecla le quitaría al usuario algo que no pidió quitar.
 */
export function useCierreConEscape(activo: boolean, cerrar: () => void) {
  useEffect(() => {
    if (!activo) return
    const alPresionar = (e: KeyboardEvent) => {
      if (e.key !== 'Escape' || e.defaultPrevented) return
      if (document.querySelector('[aria-modal="true"]')) return
      cerrar()
    }
    document.addEventListener('keydown', alPresionar)
    return () => document.removeEventListener('keydown', alPresionar)
  }, [activo, cerrar])
}
